// Shared Horizon add mechanism — mirrors the validated Adult contract exactly.
  // Defines window.__tacAddSet so TACBundleCore.addBundle refreshes the grouped
  // cart drawer via CartLinesUpdateEvent + section rendering. If the events
  // module is unavailable, the core falls back to a section-aware AJAX add.
  // Never navigates to /cart. (Adult's own copy is unchanged and frozen.)
  try {
    if (!window.__tacAddSet) {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      window.__tacAddSet = async function (items) {
        const ids = [];
        document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); });
        const deferred = CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }), promise: deferred.promise }));
        let resp;
        try {
          resp = await fetch(Theme.routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items.map(function (i) { return { id: Number(i.id), quantity: i.quantity, properties: i.properties }; }), sections: ids.join(',') }) }).then(function (r) { return r.json(); });
        } catch (e) { deferred.reject(e); throw e; }
        if (resp && resp.status) { deferred.reject(new Error(resp.message || 'add failed')); throw new Error(resp.message || 'add failed'); }
        const cart = await fetch(Theme.routes.cart_url + '.json', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: resp.sections, source: 'tac-kids-configurator', itemCount: items.reduce(function (s, i) { return s + i.quantity; }, 0), didError: false } });
        return cart;
      };
    }
  } catch (e) {}
